import { useContext, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { GridContext } from '../index';

export const useClientSortingPaging = ({
  sortFunction,
}) => {
  const { state, dispatch } = useContext(GridContext);
  const { sortedColumn, pagination, sourceItemsInAllPages } = state;
  const { pageNumber, pageSize } = pagination;

  useEffect(() => {
    if (sourceItemsInAllPages && sortFunction && !isEmpty(sortedColumn)) {
      const newSourceItems = [...sourceItemsInAllPages].sort(sortFunction);
      dispatch({ type: 'SET_ITEMS_IN_ALL_PAGES', payload: newSourceItems });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, sortFunction, sortedColumn]);

  useEffect(() => {
    if (sourceItemsInAllPages) {
      const newItems = sourceItemsInAllPages.slice((pageNumber - 1) * pageSize, (pageNumber) * pageSize);
      dispatch({ type: 'FINISH_LOAD_DATA', payload: { items: newItems, totalCount: sourceItemsInAllPages.length } });
    }
  }, [dispatch, pageNumber, pageSize, sourceItemsInAllPages]);
};
